<template>
    <div>
        <template v-if="log_shipping == true">
            <div class="page-top mb-1 mb-3">
                <h1> Edit Log Shipping </h1>
            </div>
            <div class="global-main">
                <form id="LogshippingTable" @submit.prevent="updateLogShippingDocument" novalidate>
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Table Name <em class="required">*</em> </label>
                            <input :disabled="form.table_name" v-model="form.table_name" type="text" name="key" class="form-control" :class="{ 'is-invalid': form.errors.has('table_name') }" maxlength="50">
                            <has-error :form="form" field="table_name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Day of month <em class="required">*</em></label>
                            <select id="daysDropdown" multiple v-model="form.day_of_month" class=" selectpicker form-control custom-select2" :class="{ 'is-invalid': form.errors.has('day_of_month') }">
                                <option v-for="day in totalMonthDays" :key="day" :value="day">{{ day }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label> Retention Days  <em class="required">*</em></label>
                            <input v-model="form.retention_days" type="number" name="retention_days" class="form-control" :class="{ 'is-invalid': form.errors.has('retention_days') }" maxlength="150">
                            <has-error :form="form" field="comment"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Status <em class="required">*</em></label>
                            <select v-model="form.status" name="status_select" class=" selectpicker form-control custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="ON">ON</option>
                                <option value="OFF">OFF</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/logshippingComponent" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>

                </form>
            </div>
        </template>
        <template v-else-if="log_shipping === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="log_shipping === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                form: new Form({
                    table_name: "",
                    day_of_month:[],
                    retention_days:'',
                    status:""
                }),
                log_shipping: null,
                totalMonthDays: []
            };
        },
        methods: {
            updateLogShippingDocument() {
                let jsonData = {};
                $.each(this.form, (key, value) => {
                    if (key !== 'busy' && key !== 'successful' && key !== 'errors' && key !== 'originalData') {
                        jsonData[key] = key === 'day_of_month' && Array.isArray(value) ? value.join(',') : value;
                    }
                });
                axios.put('/api/logShipping/' + this.$route.params.id,jsonData )
                    .then(res => {
                        if(res.status == 200){
                            if(res.data.code == '200'){
                                this.showToastBox("success", "Log Shipping updated successfully");
                                this.$router.push("/logshippingComponent");
                                this.$Progress.finish();
                            }else{
                                var error_msg = '';
                                error_msg = 'Please provide following details:'+'\n';
                                $.each(res.data.data, (key, value) => {
                                    error_msg += value +'\n';
                                });
                                this.showAlertBox('error',error_msg);
                                this.$Progress.fail();
                            }
                        }else{
                            this.$Progress.fail();
                            this.showAlertBox('error','Some problem in your form data');
                        }
                    }).then(res=>{
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                })

                    .catch(errors => {
                        this.promptValidationErrors(errors);
                    });
            },
            getlogShippingDocumentData() {
                let that = this;
                axios.get("/api/logShipping/" + this.$route.params.id)
                    .then((res) => {
                        if (res.data.code == 200) {
                            that.form.table_name = res.data.data.table_name;
                            that.form.day_of_month = res.data.data.day_of_month
                                .split(',')
                                .map(day => parseInt(day))
                                .filter(day => day <= 28);
                            that.form.retention_days = res.data.data.retention_days;
                            that.form.status = res.data.data.status;
                            that.form.created_at = res.data.data.created_at;
                            that.form.updated_at = res.data.data.updated_at;
                            setTimeout(function(){
                                $('.selectpicker').selectpicker('refresh');

                            },0)
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                        }
                    })
                    .catch((err) => {
                        this.$Progress.fail();
                        this.showAlertBox("error", "Some error in your form data");
                    });
            },
            generateTotalDays() {
                for (let i = 1; i <= 28; i++) {
                    this.totalMonthDays.push(i);
                }
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("log_shipping")
                .then((result) => {
                    this.log_shipping = result.log_shipping;
                })
                .then((result) => {
                    if (this.log_shipping == true) {
                        this.getlogShippingDocumentData();
                        this.generateTotalDays();
                        this.$Progress.finish();
                        this.$nextTick(() => {
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                        });
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
